import { all } from 'redux-saga/effects';
import searchNotificationsSagas from './SearchNotifications/sagas';
import deleteSearchNotificationSagas from './DeleteSearchNotification/sagas';
import disableAllSearchNotificationSagas from './DisableSearchNotifications/sagas';

export default function* notificationsManagerSagas() {
  yield all([
    searchNotificationsSagas(),
    deleteSearchNotificationSagas(),
    disableAllSearchNotificationSagas(),
  ]);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/sagas.js